export const round = (num, precision = 0)=>{
    const factor = 10 ** precision;
    return Math.round(num * factor) / factor;
};

//# sourceMappingURL=round.js.map